var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalPopover",
            centered: "",
            "cancel-disabled": "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            "hide-footer": "",
            title: _vm.$t("videoSession")
          },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "mx-auto",
              staticStyle: { width: "96px", margin: "20px 0 40px 0" }
            },
            [
              _c("img", {
                attrs: {
                  width: "96px",
                  height: "96px",
                  src: "/static-appopensalud/img/icons/video-icon.svg"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("p", { staticStyle: { "text-align": "center" } }, [
            _vm._v(_vm._s(_vm.$t("needValidToken")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col text-center pt-1" },
            [
              _c("b-input", {
                attrs: {
                  id: "token-input",
                  placeholder: _vm.$t("introduce-token")
                },
                model: {
                  value: _vm.smallToken,
                  callback: function($$v) {
                    _vm.smallToken = $$v
                  },
                  expression: "smallToken"
                }
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", "align-h": "center" },
                  on: { click: _vm.goToSession }
                },
                [_vm._v(_vm._s(_vm.$t("go-to-session")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-debabb96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-debabb96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/Start.vue
// module id = 3567
// module chunks = 105